import { IImage, IRequestedImageSize, TImageFormat } from '../interfaces'

const REQUESTED_IMAGE_SIZE_NOT_PROVIDED = 'Image mapper: image size object not provided'

export const mapImage = (image: IImage, requestedImageSize: IRequestedImageSize): TImageFormat => {
  if (!requestedImageSize) {
    throw Error(REQUESTED_IMAGE_SIZE_NOT_PROVIDED)
  }

  const { height: requestedHeight, width: requestedWidth } = requestedImageSize
  const { renditions = [], meta_data: { alt } = {} } = image

  const selectedImageData = renditions.find(
    (image) => image.width === requestedWidth && image.height === requestedHeight
  )

  return {
    ...selectedImageData,
    alt,
  }
}
